import React from "react";
import PropTypes from "prop-types";
import {isEmpty} from "lodash";
import { failure, success } from "../../../constants/images"
import PasswordStrengthMeter from "../../../components/common/PasswordStrengthMeter/PasswordStrengthMeter";

export function PasswordRequirementsOutline({
  password, 
  isPasswordLengthValid,
  isPasswordUppercase,
  isPasswordLowercase,
  isPasswordNumber,
  isPasswordSpecialCharacter,
  passwordStrengthScore,
}) {

  return (
    <div className="u--paddingSmall-bottom">
      <div className="u--paddingNone-left">
        <div className="u__bold">
          Passwords must contain:
        </div>
        <div className="password-req-entry u--paddingSmall-bottom">
          <div className="req-icon">
            {!isEmpty(password.value) && isPasswordLengthValid ? 
              success
              :
              failure
            }
          </div>
          <span> 9 characters minimum</span>
        </div>  
      </div>
      <div className="u--paddingXsmall-top u--paddingNone-left">
        <div className="u__bold">
          And 3 of the following:
        </div>
        <div className="password-req-collection u--paddingSmall-bottom">
          <div className="password-req-entry">
            <div className="req-icon">
              {!isEmpty(password.value) && isPasswordUppercase ?
                success
                :
                failure
              }
            </div>
            <span> Uppercase letter</span>
          </div>
          <div className="password-req-entry">
            <div className="req-icon">
              {!isEmpty(password.value) && isPasswordNumber ?
                success
                :
                failure
              }
            </div>
            <span> Number</span>
          </div>
          <div className="password-req-entry">
            <div className="req-icon">
              {!isEmpty(password.value) && isPasswordLowercase ?
                success
                :
                failure
              }
            </div>
            <span> Lowercase letter</span>
          </div>
          <div className="password-req-entry">
            <div className="req-icon">
              {!isEmpty(password.value) && isPasswordSpecialCharacter ?
                success
                :
                failure
              }
            </div>
            <span> Special characters</span>
          </div>
        </div>
        <PasswordStrengthMeter 
          passwordStrength={passwordStrengthScore}
        />
      </div>
      <div className="u--padding-top">
        {"Avoid repeating passwords from other websites or using phrases that might be easy to guess."}
      </div>
    </div>
  );
}

PasswordRequirementsOutline.propTypes = {
  password: PropTypes.object.isRequired, 
  isPasswordLengthValid: PropTypes.bool.isRequired,
  isPasswordUppercase: PropTypes.bool.isRequired,
  isPasswordLowercase: PropTypes.bool.isRequired,
  isPasswordNumber: PropTypes.bool.isRequired,
  isPasswordSpecialCharacter: PropTypes.bool.isRequired,
  passwordStrengthScore: PropTypes.number.isRequired,
  //isTextBodyVisible: PropTypes.bool.isRequired
}

export default PasswordRequirementsOutline;